export default {
    landing: {
        title: 'Bitdeer App',
        sub: 'One-stop Bitcoin Mining',
        desc: 'Register, accumulate, withdraw, and view hashrate output—all in the App.',
        register: 'Register Now',
        login: 'Already have an account? Log In',
        feature1: 'Reservation reward 10 USDT / day',
        feature2: 'Withdraw anytime over 10 USDT, 0 fee',
        feature3: '24/7 Japanese customer service'
    },
    login: {
        title: 'Log In',
        sub: 'Welcome back',
        email: 'Email',
        emailPlaceholder: 'Enter your email',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        submit: 'Log In',
        noAccount: 'Don\'t have an account?',
        register: 'Register Now',
        success: 'Login successful',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Invalid email format',
        passwordRequired: 'Please enter your password'
    },
    register: {
        title: 'Sign Up',
        sub: 'Start your mining journey',
        email: 'Email',
        emailPlaceholder: 'Enter your email',

        // 👇 删除了 code 相关的验证码字段

        password: 'Password',
        passwordPlaceholder: 'At least 6 characters',

        // 👇 新增：确认密码字段
        confirmPasswordPlaceholder: 'Confirm Password',
        confirmPasswordRequired: 'Please confirm your password',
        passwordMismatch: 'Passwords do not match',

        referral: 'Referral Code',
        referralPlaceholder: 'Enter referral code',
        agree: 'I have read and agree to the',
        terms: 'Terms of Service',
        and: 'and',
        privacy: 'Privacy Policy',
        submit: 'Sign Up',
        hasAccount: 'Already have an account?',
        login: 'Log In',
        success: 'Registration successful',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Invalid email format',
        passwordRequired: 'Please enter your password',
        passwordTooShort: 'Password must be at least 6 characters',
        referralRequired: 'Please enter a referral code',
        agreeRequired: 'Please agree to the Terms of Service',
        registerSuccess: 'Registration successful, please log in',
    },
    success: {
        title: 'Reservation Successful!',
        sub: 'Your account is ready',
        userId: 'User ID',
        email: 'Email',
        inviteCode: 'Your Invite Code',
        copy: 'Copy',
        copied: 'Invite code copied',
        tip: 'Share this invite code with friends. Once they register, you will be their referrer.',
        downloadAndroid: 'Android Download',
        downloadIos: 'iOS Download',
        platformTip: 'You reserved the {platform} version',
        backHome: 'Back to Home'
    }
}